
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die Krise wird für alle Staaten teuer. Das Schweizer Parlament bewilligte im Rahmen der Sondersession von Anfang Mai Kredite in der Höhe von 57 Milliarden Franken für die Folgen der Coronakrise, darunter 40 Mrd. für Bürgschaften für KMUs und 11,3 Mrd. für Kurzarbeit und Erwerbsersatz. Auch Schweden hat ein `}<a parentName="p" {...{
        "href": "https://www.government.se/articles/2020/03/economic-measures-in-response-to-covid-19/"
      }}>{`umfassendes Hilfpaket`}</a>{` für die Wirtschaft verabschiedet. Gemäss einer `}<a parentName="p" {...{
        "href": "http://www.ceyhunelgin.com"
      }}>{`Studie`}</a>{` des Wirtschaftsprofessors Ceyhun Elgin von der Columbia-Universität liegt das Hilfspaket der Schweiz im internationalen Vergleich mit 10,4 Prozent des BIP auf Platz 18, das schwedische mit 13,5 Prozent auf Platz 8.`}</p>
    <p>{`Wie viel der Unterstützungsleistungen schliesslich als Staatsausgaben verbucht werden müssen, ist noch nicht klar. Der IWF sagt allerdings in seinem `}<a parentName="p" {...{
        "href": "https://www.imf.org/en/Publications/FM/Issues/2020/04/06/fiscal-monitor-april-2020"
      }}>{`«Fiscal Minitor»`}</a>{` vom April für 2020 einen deutlichen Anstieg der Staatsverschuldung in beiden Ländern voraus.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;